import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../utils/fetchers";
import { getAdminAccessToken } from "../../utils/auth";
import { Role, RoleDetail } from "../../types/modules/admin/role.type";

export const useRolesByAdmin = (withCounts?: boolean) => {
  const token = getAdminAccessToken();
  return useQuery({
    queryKey: ["roles-by-admin"],
    queryFn: () => fetcher<Role[]>(`role?withCounts=${withCounts}`, token),
  });
};

export const useRolesDetailsByAdmin = (
  roleId: number,
  withAdmins?: boolean
) => {
  const token = getAdminAccessToken();
  return useQuery({
    queryKey: ["role-delails-by-admin", roleId, withAdmins],
    queryFn: () =>
      fetcher<RoleDetail>(`role/${roleId}?withAdmins=${withAdmins}`, token),
  });
};
